<template>
  <div id="home" class="introduction position-relative">
    <div class="bg-degraded d-flex justify-content-center align-items-center h-100">
      <div class="text-light text-center">
        <h1><strong>{{ $t('introduction.greeting') }}</strong></h1>
        <h1 class="d-inline d-md-flex align-items-end text-primary"><img src="../assets/images/logo.png" class="logo" />eisson Francois Rosas Céspedes</h1>
        <h3>{{ $t('introduction.description') }}</h3>
        <a class="btn btn-primary btn-lg js-scroll-trigger" href="#contact" @click="anchorSoftAnimation" ref="btnContact">{{ $t('action.contact') }}</a>
        <ul class="list-inline list-unstyled py-2">
          <li class="list-inline-item"><a href="https://www.linkedin.com/in/jeisson-fran%C3%A7ois-rosas-c%C3%A9spedes/" title="LinkedIn"><i class="fab fa-linkedin-in"></i></a></li>
        </ul>
      </div>
    </div>
    <NextButton path="#about" />
  </div>
</template>

<script>
import NextButton from './Tools/NextButton.vue'
import animationsMixin from '@/mixins/animations'
import requestAnimationFrame from '@/plugins/animation-frame'

export default {
  mixins: [ animationsMixin ],
  name: 'introduction',
  components: { NextButton },
  mounted () {
    requestAnimationFrame(this.shakeContactButton)
  },
  methods: {
    shakeContactButton () {
      setTimeout(() => {
        window.jQuery(this.$refs.btnContact).effect('shake', {}, 500)
        requestAnimationFrame(this.shakeContactButton)
      }, 30000)
    }
  }
}
</script>

<style scoped>
.introduction {
  width: 100%;
  height: calc(100vh - 40px);
  background-image: url('../assets/images/background.png');
}

.bg-degraded {
  background-color: rgba(38, 38, 38, 0.8);
}

.logo {
  max-height: 100px;
}

@media (max-width: 768px) {
  .logo {
    max-height: 50px;
  }
}
</style>
